<template>
  <div class="button_menu">
    <div v-show="index!=0" @click="backTop" class="item_box">
      <div>
        <img src="//txwl.huohuoche.com/txws/new_images_one/button_top.png" />
      </div>
      <span>返回顶部</span>
    </div>
    <div @click="concatUs" class="item_box">
      <div>
        <img src="//txwl.huohuoche.com/txws/new_images_one/button_phone.png" />
      </div>
      <span>联系我们</span>
    </div>
    <div @click="openEdition" class="item_box">
      <div>
        <img src="//txwl.huohuoche.com/txws/new_images_one/button_plus.png" />
      </div>
      <span>我要开版</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "txButtons",
  props: {
    index: 0
  },
  data() {
    return {};
  },
  created: function() {},
  methods: {
    //返回顶部
    backTop() {
      this.$emit("backTop", 0);
    },
    //开版
    openEdition() {
      this.$store.commit("CHANGEOPENEDITIONSTATUS", true);
      this.$store.commit("CHANGECONCATUSSTATUS", false);
      this.utils.animateCSS(".box", [
        "animate__zoomIn",
        "animate__delay-decimal2s"
      ]);
    },
    concatUs() {
      this.$store.commit("CHANGECONCATUSSTATUS", true);
      this.$store.commit("CHANGEOPENEDITIONSTATUS", false);
      this.utils.animateCSS(".concat", [
        "animate__zoomIn",
        "animate__delay-decimal2s"
      ]);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.button_menu {
  position: absolute;
  right: 3%;
  bottom: 3%;
  width: 80px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  .item_box:hover{
    div{
      background:#99264B;
    }
  }
  .item_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
    cursor: pointer;
    div {
      width: 50px;
      height:50px;
      background:#42436C;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      img {
        width: 40%;
        // height: 100%;
        display: block;
      }
    }
    span {
      font-size: $fontSize_16;
      font-family: PingFang SC;
      font-weight: 300;
      color: #9d9da5;
      line-height: 10px;
      margin: 15px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/tx-buttons.vue